import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
    FormGroupTextarea,
    FormGroup,
    FormGroupSelect,
} from '@paysera/react-common';
import PropTypes from 'prop-types';

import FormGroupDropZone from '@assetsJsModule/dropzone';
import getFileSizeNotice from '@assetsJsModule/dropzone/service/getFileSizeNotice';

import { PRODUCT_SELECT_LABELS, FIELD_NAMES } from '../config/constants';

const ContactUsFormFields = ({
    maxFileSize,
    maxTotalFilesSize,
    maxNumberOfFiles,
    columnGridCount,
    allowedMimeTypes,
}) => {
    const { t } = useTranslation('PayseraContactFormBundle');

    const productOptions = PRODUCT_SELECT_LABELS.map(item => ({
        id: t(item),
        label: t(item),
    }));

    const cleanFieldName = value => value.trim().slice(0, -1);

    return (
        <div className="row">
            <div className="col-md-6">
                <div className="row">
                    <FormGroup
                        name={FIELD_NAMES.name}
                        label={cleanFieldName(t('contact_form.contact.name'))}
                        type="text"
                        wrapperClassName="form-group col-md-6"
                        autoComplete="given-name"
                        aria-describedby="name-help"
                    />
                    <FormGroup
                        name={FIELD_NAMES.email}
                        label={cleanFieldName(t('contact_form.contact.email'))}
                        type="email"
                        wrapperClassName="form-group col-md-6"
                        autoComplete="email"
                        aria-describedby="email-help"
                    />
                    <FormGroup
                        name={FIELD_NAMES.companyName}
                        label={t('contact_form.contact.company_name')}
                        type="text"
                        wrapperClassName="form-group col-md-12"
                        autoComplete="organization"
                        aria-describedby="company-help"
                    />
                    <FormGroupSelect
                        name={FIELD_NAMES.product}
                        label={t('contact_form.contact.product')}
                        placeholderOption={t('contact_form.contact.product.placeholder')}
                        options={productOptions}
                        wrapperClassName="form-group col-md-12"
                        aria-describedby="product-help"
                    />
                    <FormGroupTextarea
                        name={FIELD_NAMES.message}
                        label={cleanFieldName(t('contact_form.contact.message'))}
                        rows="7"
                        wrapperClassName="form-group col-md-12"
                        aria-describedby="message-help"
                        placeholder={t('contact_form.contact.message.placeholder', '')}
                    />
                </div>
            </div>

            <div className="col-md-6">
                <FormGroupDropZone
                    title={t('contact_form.contact.files.title')}
                    name={FIELD_NAMES.attachments}
                    contentBase64Encoded
                    maxFileSizeMB={maxFileSize}
                    maxTotalFilesSizeMB={maxTotalFilesSize}
                    maxTotalFilesCount={maxNumberOfFiles}
                    columnGridCount={columnGridCount}
                    notice={getFileSizeNotice(maxFileSize, maxNumberOfFiles)}
                    allowedMimeTypes={allowedMimeTypes}
                />
            </div>
        </div>
    );
};

ContactUsFormFields.propTypes = {
    maxFileSize: PropTypes.number.isRequired,
    maxTotalFilesSize: PropTypes.number.isRequired,
    maxNumberOfFiles: PropTypes.number.isRequired,
    columnGridCount: PropTypes.number.isRequired,
    allowedMimeTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default memo(ContactUsFormFields);
